// extracted by mini-css-extract-plugin
module.exports = {"container":"oCSaDR2ufVa-UPYBtANGe","groupsList":"_31bm25p8xCyaxTHkJacErC"};